export const environment = {
    production: true,
    baseUrl: "http://silaomunicipal.com/api",
    languages: ["silaoEnglish", "silaoHindi"],
    defaultLanguage: "silaoEnglish",
    gmapapiKey:'AIzaSyDiIcPjfIP_bxafULUIkvkq_aaTml_CGqc'   

};